import React from "react";
import {
  Parah,
  PointsIcon,
  PointsWrapper,
  SubTitle,
  ThirdTitle,
} from "../ContentsStyles";

const CG_6 = () => {
  return (
    <>
      <Parah>
        Talents Explore is a diverse and inclusive community that has no
        tolerance for discrimination. We do not permit content that contains
        hate speech or involves hateful behaviour, and we remove it from our
        platform. We ban accounts and/or users that engage in severe or multiple
        hate speech violations or that are associated with hate speech off the
        Talents Explore platform.
      </Parah>
      <SubTitle>
        Attacks and Slurs on the Basis of Protected Attributes
      </SubTitle>
      <Parah>
        We define hate speech or behaviour as content that attacks, threatens,
        incites violence against, or otherwise dehumanizes an individual or a
        group on the basis of the following protected attributes:
      </Parah>
      <ThirdTitle>Do not post, upload, stream, or share:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Race
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Ethnicity
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        National origin
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Religion
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Caste
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Sexual orientation
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Sex
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Gender
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Gender identity
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Serious disease
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Disability
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Immigration status
      </PointsWrapper>
      <Parah>
        Slurs are defined as derogatory terms that are intended to disparage
        groups or individuals based on any protected attributes listed above. To
        minimize the spread of egregiously offensive terms, we remove all slurs
        from our platform, unless the terms are reappropriated, used
        self-referentially (i.e., by members of the protected group), or used in
        a way that does not disparage (e.g., educational context).
      </Parah>
      <ThirdTitle>Do not post, upload, stream, or share:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Content claiming individuals or groups with protected attributes are
        physically, mentally, or morally inferior or referring to them as
        criminals, animals, inanimate objects, or other non-human entities.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content claiming individuals or groups with protected attributes are
        physically, mentally, or morally inferior or referring to them as
        criminals, animals, inanimate objects, or other non-human entities.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content promoting or justifying violence, exclusion, segregation, or
        discrimination against them.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that targets transgender or non-binary individuals through
        misgendering or deadnaming.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that depicts harm inflicted upon an individual.
      </PointsWrapper>
      <SubTitle>Hateful Ideology</SubTitle>
      <Parah>
        Hateful ideologies are those that demonstrate clear hostility toward
        people because of their protected attributes. Hateful ideologies are
        incompatible with the inclusive and supportive community that our
        platform provides, and we remove content that promotes them.
      </Parah>
      <ThirdTitle>Do not post, upload, stream, or share:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Content that praises, promotes, glorifies, or supports any hateful
        ideology (e.g., white supremacy, misogyny, anti-LGBTQ, antisemitism).
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that contains names, symbols, logos, flags, slogans, uniforms,
        gestures, salutes, illustrations, portraits, songs, music, lyrics, or
        other objects related to a hateful ideology.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that promotes, supports, or advertises conversion therapy or
        related program.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that denies well-documented and violent events have taken place
        affecting groups with protected attributes (e.g., Holocaust denial).
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Claims of supremacy over a group of people with reference to other
        protected attributes.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Conspiracy theories used to justify hateful ideologies.
      </PointsWrapper>
    </>
  );
};

export default CG_6;
